import { FC, SVGProps } from "react";
import clsx from "clsx";

// ----------------------------------------------------------------------------------

export type ITeamsProps = SVGProps<SVGSVGElement> & {
  variant: "white" | "black" | "normal";
};

const Teams: FC<ITeamsProps> = (props) => {
  const { variant, className, ...other } = props;

  return (
    <>
      {variant === "white" && (
        <svg
          width="20"
          height="20"
          viewBox="0 0 31 29"
          fill="none"
          className={clsx("rounded-sm bg-white p-1", className)}
          xmlns="http://www.w3.org/2000/svg"
          {...other}
        >
          <g clipPath="url(#clip0_1304_6755)">
            <path
              d="M21.4252 11H29.1743C29.9064 11 30.4999 11.5955 30.4999 12.33V19.4119C30.4999 22.1115 28.3187 24.3 25.628 24.3H25.605C22.9143 24.3004 20.7328 22.1122 20.7324 19.4126C20.7324 19.4124 20.7324 19.4121 20.7324 19.4119V11.6951C20.7324 11.3112 21.0426 11 21.4252 11Z"
              fill="#054ADA"
            />
            <path
              d="M26.663 9.60005C28.3969 9.60005 29.8025 8.18975 29.8025 6.45005C29.8025 4.71035 28.3969 3.30005 26.663 3.30005C24.9291 3.30005 23.5234 4.71035 23.5234 6.45005C23.5234 8.18975 24.9291 9.60005 26.663 9.60005Z"
              fill="#054ADA"
            />
            <path
              d="M16.8962 9.60001C19.4008 9.60001 21.4311 7.5629 21.4311 5.05C21.4311 2.53711 19.4008 0.5 16.8962 0.5C14.3917 0.5 12.3613 2.53711 12.3613 5.05C12.3613 7.5629 14.3917 9.60001 16.8962 9.60001Z"
              fill="#054ADA"
            />
            <path
              d="M22.9413 11H10.1501C9.42677 11.018 8.85453 11.6203 8.87131 12.3461V20.4234C8.7703 24.779 12.2048 28.3934 16.5457 28.5C20.8867 28.3934 24.3212 24.779 24.2202 20.4234V12.3461C24.2369 11.6203 23.6647 11.018 22.9413 11Z"
              fill="#054ADA"
            />
            <path
              opacity="0.1"
              d="M17.2436 11V22.319C17.2401 22.8381 16.9266 23.3044 16.4482 23.502C16.2959 23.5666 16.1322 23.6 15.9668 23.6H9.48542C9.39472 23.369 9.311 23.138 9.24123 22.9C8.99701 22.0968 8.8724 21.2618 8.87145 20.422V12.344C8.85468 11.6193 9.42598 11.018 10.1482 11H17.2436Z"
              fill="#FFFFFF"
            />
            <path
              opacity="0.2"
              d="M16.5459 11V23.019C16.5459 23.1849 16.5126 23.3492 16.4482 23.502C16.2512 23.982 15.7865 24.2965 15.2691 24.3H9.81333C9.69472 24.069 9.58309 23.838 9.48542 23.6C9.38774 23.362 9.311 23.138 9.24123 22.9C8.99701 22.0968 8.8724 21.2618 8.87145 20.422V12.344C8.85468 11.6193 9.42598 11.018 10.1482 11H16.5459Z"
              fill="#FFFFFF"
            />
            <path
              opacity="0.2"
              d="M16.5459 11V21.619C16.5406 22.3243 15.9721 22.8947 15.2691 22.9H9.24123C8.99701 22.0968 8.8724 21.2618 8.87145 20.422V12.344C8.85468 11.6193 9.42598 11.018 10.1482 11H16.5459Z"
              fill="#FFFFFF"
            />
            <path
              opacity="0.2"
              d="M15.8482 11V21.619C15.8429 22.3243 15.2744 22.8947 14.5715 22.9H9.24123C8.99701 22.0968 8.8724 21.2618 8.87145 20.422V12.344C8.85468 11.6193 9.42598 11.018 10.1482 11H15.8482Z"
              fill="#FFFFFF"
            />
            <path
              opacity="0.1"
              d="M17.2445 7.38108V9.58608C17.1259 9.59308 17.0142 9.60009 16.8956 9.60009C16.777 9.60009 16.6654 9.59309 16.5468 9.58608C16.3113 9.57041 16.0777 9.53292 15.8491 9.47409C14.4363 9.1384 13.2691 8.14428 12.7096 6.80009C12.6133 6.57436 12.5386 6.33997 12.4863 6.1001H15.9677C16.6717 6.10277 17.2418 6.67471 17.2445 7.38108Z"
              fill="#FFFFFF"
            />
            <path
              opacity="0.2"
              d="M16.5462 8.08079V9.5858C16.3107 9.57012 16.0771 9.53263 15.8485 9.4738C14.4357 9.13811 13.2685 8.14399 12.709 6.7998H15.2694C15.9735 6.80248 16.5435 7.37443 16.5462 8.08079Z"
              fill="#FFFFFF"
            />
            <path
              opacity="0.2"
              d="M16.5462 8.08079V9.5858C16.3107 9.57012 16.0771 9.53263 15.8485 9.4738C14.4357 9.13811 13.2685 8.14399 12.709 6.7998H15.2694C15.9735 6.80248 16.5435 7.37443 16.5462 8.08079Z"
              fill="#FFFFFF"
            />
            <path
              opacity="0.2"
              d="M15.8485 8.0808V9.4738C14.4357 9.13811 13.2685 8.14399 12.709 6.7998H14.5718C15.2758 6.80249 15.8458 7.37445 15.8485 8.0808Z"
              fill="#FFFFFF"
            />
            <path
              d="M1.77883 6.80005H14.57C15.2763 6.80005 15.8488 7.37452 15.8488 8.08314V20.9169C15.8488 21.6256 15.2763 22.2 14.57 22.2H1.77883C1.07255 22.2 0.5 21.6256 0.5 20.9169V8.08314C0.5 7.37452 1.07256 6.80005 1.77883 6.80005Z"
              fill="#054ADA"
            />
            <path
              d="M11.5398 11.6843H8.98277V18.6703H7.35371V11.6843H4.80859V10.3291H11.5398V11.6843Z"
              fill="#FFFFFF"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_1304_6755"
              x1="3.1664"
              y1="5.79746"
              x2="13.2325"
              y2="23.1736"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#8F8F8F" />
              <stop offset="0.5" stop-color="#858585" />
              <stop offset="1" stop-color="#727272" />
            </linearGradient>
            <clipPath id="clip0_1304_6755">
              <rect
                width="30"
                height="28"
                fill="white"
                transform="translate(0.5 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}

      {variant === "black" && (
        <svg
          width="25"
          height="25"
          viewBox="0 0 31 29"
          fill="none"
          className={clsx("rounded-sm bg-black-900 p-1", className)}
          xmlns="http://www.w3.org/2000/svg"
          {...other}
        >
          <g clipPath="url(#clip0_1304_6755)">
            <path
              d="M21.4252 11H29.1743C29.9064 11 30.4999 11.5955 30.4999 12.33V19.4119C30.4999 22.1115 28.3187 24.3 25.628 24.3H25.605C22.9143 24.3004 20.7328 22.1122 20.7324 19.4126C20.7324 19.4124 20.7324 19.4121 20.7324 19.4119V11.6951C20.7324 11.3112 21.0426 11 21.4252 11Z"
              fill="#EFFBFF"
            />
            <path
              d="M26.663 9.60005C28.3969 9.60005 29.8025 8.18975 29.8025 6.45005C29.8025 4.71035 28.3969 3.30005 26.663 3.30005C24.9291 3.30005 23.5234 4.71035 23.5234 6.45005C23.5234 8.18975 24.9291 9.60005 26.663 9.60005Z"
              fill="#EFFBFF"
            />
            <path
              d="M16.8962 9.60001C19.4008 9.60001 21.4311 7.5629 21.4311 5.05C21.4311 2.53711 19.4008 0.5 16.8962 0.5C14.3917 0.5 12.3613 2.53711 12.3613 5.05C12.3613 7.5629 14.3917 9.60001 16.8962 9.60001Z"
              fill="#EFFBFF"
            />
            <path
              d="M22.9413 11H10.1501C9.42677 11.018 8.85453 11.6203 8.87131 12.3461V20.4234C8.7703 24.779 12.2048 28.3934 16.5457 28.5C20.8867 28.3934 24.3212 24.779 24.2202 20.4234V12.3461C24.2369 11.6203 23.6647 11.018 22.9413 11Z"
              fill="#EFFBFF"
            />
            <path
              opacity="0.1"
              d="M17.2436 11V22.319C17.2401 22.8381 16.9266 23.3044 16.4482 23.502C16.2959 23.5666 16.1322 23.6 15.9668 23.6H9.48542C9.39472 23.369 9.311 23.138 9.24123 22.9C8.99701 22.0968 8.8724 21.2618 8.87145 20.422V12.344C8.85468 11.6193 9.42598 11.018 10.1482 11H17.2436Z"
              fill="#252C37"
            />
            <path
              opacity="0.2"
              d="M16.5459 11V23.019C16.5459 23.1849 16.5126 23.3492 16.4482 23.502C16.2512 23.982 15.7865 24.2965 15.2691 24.3H9.81333C9.69472 24.069 9.58309 23.838 9.48542 23.6C9.38774 23.362 9.311 23.138 9.24123 22.9C8.99701 22.0968 8.8724 21.2618 8.87145 20.422V12.344C8.85468 11.6193 9.42598 11.018 10.1482 11H16.5459Z"
              fill="#252C37"
            />
            <path
              opacity="0.2"
              d="M16.5459 11V21.619C16.5406 22.3243 15.9721 22.8947 15.2691 22.9H9.24123C8.99701 22.0968 8.8724 21.2618 8.87145 20.422V12.344C8.85468 11.6193 9.42598 11.018 10.1482 11H16.5459Z"
              fill="#252C37"
            />
            <path
              opacity="0.2"
              d="M15.8482 11V21.619C15.8429 22.3243 15.2744 22.8947 14.5715 22.9H9.24123C8.99701 22.0968 8.8724 21.2618 8.87145 20.422V12.344C8.85468 11.6193 9.42598 11.018 10.1482 11H15.8482Z"
              fill="#252C37"
            />
            <path
              opacity="0.1"
              d="M17.2445 7.38108V9.58608C17.1259 9.59308 17.0142 9.60009 16.8956 9.60009C16.777 9.60009 16.6654 9.59309 16.5468 9.58608C16.3113 9.57041 16.0777 9.53292 15.8491 9.47409C14.4363 9.1384 13.2691 8.14428 12.7096 6.80009C12.6133 6.57436 12.5386 6.33997 12.4863 6.1001H15.9677C16.6717 6.10277 17.2418 6.67471 17.2445 7.38108Z"
              fill="#252C37"
            />
            <path
              opacity="0.2"
              d="M16.5462 8.08079V9.5858C16.3107 9.57012 16.0771 9.53263 15.8485 9.4738C14.4357 9.13811 13.2685 8.14399 12.709 6.7998H15.2694C15.9735 6.80248 16.5435 7.37443 16.5462 8.08079Z"
              fill="#252C37"
            />
            <path
              opacity="0.2"
              d="M16.5462 8.08079V9.5858C16.3107 9.57012 16.0771 9.53263 15.8485 9.4738C14.4357 9.13811 13.2685 8.14399 12.709 6.7998H15.2694C15.9735 6.80248 16.5435 7.37443 16.5462 8.08079Z"
              fill="#252C37"
            />
            <path
              opacity="0.2"
              d="M15.8485 8.0808V9.4738C14.4357 9.13811 13.2685 8.14399 12.709 6.7998H14.5718C15.2758 6.80249 15.8458 7.37445 15.8485 8.0808Z"
              fill="#252C37"
            />
            <path
              d="M1.77883 6.80005H14.57C15.2763 6.80005 15.8488 7.37452 15.8488 8.08314V20.9169C15.8488 21.6256 15.2763 22.2 14.57 22.2H1.77883C1.07255 22.2 0.5 21.6256 0.5 20.9169V8.08314C0.5 7.37452 1.07256 6.80005 1.77883 6.80005Z"
              fill="#EFFBFF"
            />
            <path
              d="M11.5398 11.6843H8.98277V18.6703H7.35371V11.6843H4.80859V10.3291H11.5398V11.6843Z"
              fill="#252C37"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_1304_6755"
              x1="3.1664"
              y1="5.79746"
              x2="13.2325"
              y2="23.1736"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#8F8F8F" />
              <stop offset="0.5" stop-color="#858585" />
              <stop offset="1" stop-color="#727272" />
            </linearGradient>
            <clipPath id="clip0_1304_6755">
              <rect
                width="30"
                height="28"
                fill="white"
                transform="translate(0.5 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}

      {variant === "normal" && (
        <svg
          width="31"
          height="29"
          viewBox="0 0 31 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={className}
          {...other}
        >
          <g clipPath="url(#clip0_1304_6755)">
            <path
              d="M21.4252 11H29.1743C29.9064 11 30.4999 11.5955 30.4999 12.33V19.4119C30.4999 22.1115 28.3187 24.3 25.628 24.3H25.605C22.9143 24.3004 20.7328 22.1122 20.7324 19.4126C20.7324 19.4124 20.7324 19.4121 20.7324 19.4119V11.6951C20.7324 11.3112 21.0426 11 21.4252 11Z"
              fill="#8D8D8D"
            />
            <path
              d="M26.663 9.60005C28.3969 9.60005 29.8025 8.18975 29.8025 6.45005C29.8025 4.71035 28.3969 3.30005 26.663 3.30005C24.9291 3.30005 23.5234 4.71035 23.5234 6.45005C23.5234 8.18975 24.9291 9.60005 26.663 9.60005Z"
              fill="#8D8D8D"
            />
            <path
              d="M16.8962 9.60001C19.4008 9.60001 21.4311 7.5629 21.4311 5.05C21.4311 2.53711 19.4008 0.5 16.8962 0.5C14.3917 0.5 12.3613 2.53711 12.3613 5.05C12.3613 7.5629 14.3917 9.60001 16.8962 9.60001Z"
              fill="#B3B3B3"
            />
            <path
              d="M22.9413 11H10.1501C9.42677 11.018 8.85453 11.6203 8.87131 12.3461V20.4234C8.7703 24.779 12.2048 28.3934 16.5457 28.5C20.8867 28.3934 24.3212 24.779 24.2202 20.4234V12.3461C24.2369 11.6203 23.6647 11.018 22.9413 11Z"
              fill="#B3B3B3"
            />
            <path
              opacity="0.1"
              d="M17.2436 11V22.319C17.2401 22.8381 16.9266 23.3044 16.4482 23.502C16.2959 23.5666 16.1322 23.6 15.9668 23.6H9.48542C9.39472 23.369 9.311 23.138 9.24123 22.9C8.99701 22.0968 8.8724 21.2618 8.87145 20.422V12.344C8.85468 11.6193 9.42598 11.018 10.1482 11H17.2436Z"
              fill="black"
            />
            <path
              opacity="0.2"
              d="M16.5459 11V23.019C16.5459 23.1849 16.5126 23.3492 16.4482 23.502C16.2512 23.982 15.7865 24.2965 15.2691 24.3H9.81333C9.69472 24.069 9.58309 23.838 9.48542 23.6C9.38774 23.362 9.311 23.138 9.24123 22.9C8.99701 22.0968 8.8724 21.2618 8.87145 20.422V12.344C8.85468 11.6193 9.42598 11.018 10.1482 11H16.5459Z"
              fill="black"
            />
            <path
              opacity="0.2"
              d="M16.5459 11V21.619C16.5406 22.3243 15.9721 22.8947 15.2691 22.9H9.24123C8.99701 22.0968 8.8724 21.2618 8.87145 20.422V12.344C8.85468 11.6193 9.42598 11.018 10.1482 11H16.5459Z"
              fill="black"
            />
            <path
              opacity="0.2"
              d="M15.8482 11V21.619C15.8429 22.3243 15.2744 22.8947 14.5715 22.9H9.24123C8.99701 22.0968 8.8724 21.2618 8.87145 20.422V12.344C8.85468 11.6193 9.42598 11.018 10.1482 11H15.8482Z"
              fill="black"
            />
            <path
              opacity="0.1"
              d="M17.2445 7.38108V9.58608C17.1259 9.59308 17.0142 9.60009 16.8956 9.60009C16.777 9.60009 16.6654 9.59309 16.5468 9.58608C16.3113 9.57041 16.0777 9.53292 15.8491 9.47409C14.4363 9.1384 13.2691 8.14428 12.7096 6.80009C12.6133 6.57436 12.5386 6.33997 12.4863 6.1001H15.9677C16.6717 6.10277 17.2418 6.67471 17.2445 7.38108Z"
              fill="black"
            />
            <path
              opacity="0.2"
              d="M16.5462 8.08079V9.5858C16.3107 9.57012 16.0771 9.53263 15.8485 9.4738C14.4357 9.13811 13.2685 8.14399 12.709 6.7998H15.2694C15.9735 6.80248 16.5435 7.37443 16.5462 8.08079Z"
              fill="black"
            />
            <path
              opacity="0.2"
              d="M16.5462 8.08079V9.5858C16.3107 9.57012 16.0771 9.53263 15.8485 9.4738C14.4357 9.13811 13.2685 8.14399 12.709 6.7998H15.2694C15.9735 6.80248 16.5435 7.37443 16.5462 8.08079Z"
              fill="black"
            />
            <path
              opacity="0.2"
              d="M15.8485 8.0808V9.4738C14.4357 9.13811 13.2685 8.14399 12.709 6.7998H14.5718C15.2758 6.80249 15.8458 7.37445 15.8485 8.0808Z"
              fill="black"
            />
            <path
              d="M1.77883 6.80005H14.57C15.2763 6.80005 15.8488 7.37452 15.8488 8.08314V20.9169C15.8488 21.6256 15.2763 22.2 14.57 22.2H1.77883C1.07255 22.2 0.5 21.6256 0.5 20.9169V8.08314C0.5 7.37452 1.07256 6.80005 1.77883 6.80005Z"
              fill="url(#paint0_linear_1304_6755)"
            />
            <path
              d="M11.5398 11.6843H8.98277V18.6703H7.35371V11.6843H4.80859V10.3291H11.5398V11.6843Z"
              fill="white"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_1304_6755"
              x1="3.1664"
              y1="5.79746"
              x2="13.2325"
              y2="23.1736"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#8F8F8F" />
              <stop offset="0.5" stop-color="#858585" />
              <stop offset="1" stop-color="#727272" />
            </linearGradient>
            <clipPath id="clip0_1304_6755">
              <rect
                width="30"
                height="28"
                fill="white"
                transform="translate(0.5 0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  );
};

export default Teams;
